import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  suppliers: [],
  tempSuppliers: [],
  isLoading: false,
  pagination: {
    total: 0,
    page: 1,
    pages: 1,
  },
};

const supplierSlice = createSlice({
  name: "suppliers",
  initialState,
  reducers: {
    setSuppliers(state, action) {
      state.suppliers = action.payload;
      state.isLoading = false;
    },
    setTempSuppliers(state, action) {
      state.tempSuppliers = action.payload;
    },
    addSupplier(state, action) {
      state.suppliers.push(action.payload);
      state.tempSuppliers.push(action.payload);
    },
    updateSupplier(state, action) {
      const { index, supplier } = action.payload;
      state.suppliers?.splice(index, 1, supplier);
      state.tempSuppliers?.splice(index, 1, supplier);
    },
    setSupplierPagination(state, action) {
      state.pagination = action.payload;
    },
    deleteSupplierItem(state, action) {
      const { index } = action.payload;
      state.suppliers.splice(index, 1);
      state.tempSuppliers.splice(index, 1);
    },
    setSupplierIsLoading(state, action) {
      state.isLoading = true;
    },
  },
});

export const {
  setSuppliers,
  setTempSuppliers,
  addSupplier,
  updateSupplier,
  deleteSupplierItem,
  setSupplierIsLoading,
  setSupplierPagination,
} = supplierSlice.actions;
export default supplierSlice.reducer;
